// Added by Sejune Oh on 2019-06-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC, RefObject } from 'react'
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Intl from '@/helper/Intl'
import { AssignedItemProps, ReactFormEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import MgmtComponentFormStyle from '@/styles/management/MgmtComponentFormStyle'
import { Typography } from '@/components/_primes'
import { MultiSelect } from '@/components/common/MultiSelect'
import { GroupElementProps } from '@/stores/mgmt/group'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface UserAssignedGroupFCProps extends WithStyles<typeof styles> {
    linkedGroupRef: RefObject<any>
    linkedGroup: AssignedItemProps<GroupElementProps>
    formSubmitBtnRef: RefObject<HTMLButtonElement>
    onFormSubmit: ReactFormEvent
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const UserAssignedGroup: FC<UserAssignedGroupFCProps> = ({ classes, ...props }) => {
    const title = Intl.getIntlText({ id: 'htmljs_react.mgmt.userassignedgroup.title_assigned_groups' })
    const labelGroups = Intl.getIntlText({ id: 'htmljs_react.mgmt.userassignedgroup.label_groups' })
    return (
        <div className={classes.FormWrapper}>
            <div className={classes.TextWrapper}>
                <Typography variant="h1" className={classes.FormTtitle}>
                    {title}
                </Typography>
            </div>
            <div className={classes.InputWrapper}>
                <form className={classes.InnerFormWrapper} onSubmit={props.onFormSubmit}>
                    <MultiSelect
                        ref={props.linkedGroupRef}
                        options={props.linkedGroup!.unassigned as Array<GroupElementProps>}
                        value={props.linkedGroup!.assigned as Array<GroupElementProps>}
                        valueProp={'id'}
                        labelProp={'group_key'}
                        isRequired={true}
                        title={labelGroups}
                    />
                    <button ref={props.formSubmitBtnRef} type="submit" hidden />
                </form>
            </div>
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) =>
    createStyles({
        ...MgmtComponentFormStyle(theme),
        InnerFormWrapper: {
            marginTop: `-${theme.spacing() / 2}px`,
        },
    })

export default withStyles(styles, { withTheme: true })(UserAssignedGroup)
